/**
 * Ensures option.articles exists as a flat union of all section articles.
 * Used as a defensive fallback at the read boundary.
 */
export const normalizeOptionArticles = (option) => {
  if (option.articles?.length > 0) return option;
  if (!option.sections?.length) return { ...option, articles: [] };
  const articles = [
    ...new Set(option.sections.flatMap((s) => s.articles || []))
  ];
  return { ...option, articles };
};
